"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "createConnector", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.createConnector;
  }
});
Object.defineProperty(exports, "HIGHLIGHT_TAGS", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.HIGHLIGHT_TAGS;
  }
});
Object.defineProperty(exports, "translatable", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.translatable;
  }
});
Object.defineProperty(exports, "Configure", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.Configure;
  }
});
Object.defineProperty(exports, "QueryRuleContext", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.QueryRuleContext;
  }
});
Object.defineProperty(exports, "connectAutoComplete", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectAutoComplete;
  }
});
Object.defineProperty(exports, "connectBreadcrumb", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectBreadcrumb;
  }
});
Object.defineProperty(exports, "connectConfigure", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectConfigure;
  }
});
Object.defineProperty(exports, "connectCurrentRefinements", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectCurrentRefinements;
  }
});
Object.defineProperty(exports, "connectGeoSearch", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectGeoSearch;
  }
});
Object.defineProperty(exports, "connectHierarchicalMenu", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectHierarchicalMenu;
  }
});
Object.defineProperty(exports, "connectHighlight", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectHighlight;
  }
});
Object.defineProperty(exports, "connectHitInsights", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectHitInsights;
  }
});
Object.defineProperty(exports, "connectHits", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectHits;
  }
});
Object.defineProperty(exports, "connectHitsPerPage", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectHitsPerPage;
  }
});
Object.defineProperty(exports, "connectInfiniteHits", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectInfiniteHits;
  }
});
Object.defineProperty(exports, "connectMenu", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectMenu;
  }
});
Object.defineProperty(exports, "connectNumericMenu", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectNumericMenu;
  }
});
Object.defineProperty(exports, "connectPagination", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectPagination;
  }
});
Object.defineProperty(exports, "connectPoweredBy", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectPoweredBy;
  }
});
Object.defineProperty(exports, "connectQueryRules", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectQueryRules;
  }
});
Object.defineProperty(exports, "connectRange", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectRange;
  }
});
Object.defineProperty(exports, "connectRefinementList", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectRefinementList;
  }
});
Object.defineProperty(exports, "connectScrollTo", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectScrollTo;
  }
});
Object.defineProperty(exports, "connectSearchBox", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectSearchBox;
  }
});
Object.defineProperty(exports, "connectSortBy", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectSortBy;
  }
});
Object.defineProperty(exports, "connectStateResults", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectStateResults;
  }
});
Object.defineProperty(exports, "connectStats", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectStats;
  }
});
Object.defineProperty(exports, "connectToggleRefinement", {
  enumerable: true,
  get: function get() {
    return _reactInstantsearchCore.connectToggleRefinement;
  }
});
Object.defineProperty(exports, "InstantSearch", {
  enumerable: true,
  get: function get() {
    return _InstantSearch.default;
  }
});
Object.defineProperty(exports, "Index", {
  enumerable: true,
  get: function get() {
    return _Index.default;
  }
});
Object.defineProperty(exports, "Breadcrumb", {
  enumerable: true,
  get: function get() {
    return _Breadcrumb.default;
  }
});
Object.defineProperty(exports, "ClearRefinements", {
  enumerable: true,
  get: function get() {
    return _ClearRefinements.default;
  }
});
Object.defineProperty(exports, "CurrentRefinements", {
  enumerable: true,
  get: function get() {
    return _CurrentRefinements.default;
  }
});
Object.defineProperty(exports, "HierarchicalMenu", {
  enumerable: true,
  get: function get() {
    return _HierarchicalMenu.default;
  }
});
Object.defineProperty(exports, "Highlight", {
  enumerable: true,
  get: function get() {
    return _Highlight.default;
  }
});
Object.defineProperty(exports, "Hits", {
  enumerable: true,
  get: function get() {
    return _Hits.default;
  }
});
Object.defineProperty(exports, "HitsPerPage", {
  enumerable: true,
  get: function get() {
    return _HitsPerPage.default;
  }
});
Object.defineProperty(exports, "InfiniteHits", {
  enumerable: true,
  get: function get() {
    return _InfiniteHits.default;
  }
});
Object.defineProperty(exports, "Menu", {
  enumerable: true,
  get: function get() {
    return _Menu.default;
  }
});
Object.defineProperty(exports, "MenuSelect", {
  enumerable: true,
  get: function get() {
    return _MenuSelect.default;
  }
});
Object.defineProperty(exports, "NumericMenu", {
  enumerable: true,
  get: function get() {
    return _NumericMenu.default;
  }
});
Object.defineProperty(exports, "Pagination", {
  enumerable: true,
  get: function get() {
    return _Pagination.default;
  }
});
Object.defineProperty(exports, "Panel", {
  enumerable: true,
  get: function get() {
    return _Panel.default;
  }
});
Object.defineProperty(exports, "PoweredBy", {
  enumerable: true,
  get: function get() {
    return _PoweredBy.default;
  }
});
Object.defineProperty(exports, "RangeInput", {
  enumerable: true,
  get: function get() {
    return _RangeInput.default;
  }
});
Object.defineProperty(exports, "RangeSlider", {
  enumerable: true,
  get: function get() {
    return _RangeSlider.default;
  }
});
Object.defineProperty(exports, "RatingMenu", {
  enumerable: true,
  get: function get() {
    return _RatingMenu.default;
  }
});
Object.defineProperty(exports, "RefinementList", {
  enumerable: true,
  get: function get() {
    return _RefinementList.default;
  }
});
Object.defineProperty(exports, "ScrollTo", {
  enumerable: true,
  get: function get() {
    return _ScrollTo.default;
  }
});
Object.defineProperty(exports, "SearchBox", {
  enumerable: true,
  get: function get() {
    return _SearchBox.default;
  }
});
Object.defineProperty(exports, "Snippet", {
  enumerable: true,
  get: function get() {
    return _Snippet.default;
  }
});
Object.defineProperty(exports, "SortBy", {
  enumerable: true,
  get: function get() {
    return _SortBy.default;
  }
});
Object.defineProperty(exports, "Stats", {
  enumerable: true,
  get: function get() {
    return _Stats.default;
  }
});
Object.defineProperty(exports, "ToggleRefinement", {
  enumerable: true,
  get: function get() {
    return _ToggleRefinement.default;
  }
});
Object.defineProperty(exports, "VoiceSearch", {
  enumerable: true,
  get: function get() {
    return _VoiceSearch.default;
  }
});
Object.defineProperty(exports, "QueryRuleCustomData", {
  enumerable: true,
  get: function get() {
    return _QueryRuleCustomData.default;
  }
});
Object.defineProperty(exports, "createClassNames", {
  enumerable: true,
  get: function get() {
    return _utils.createClassNames;
  }
});
Object.defineProperty(exports, "createVoiceSearchHelper", {
  enumerable: true,
  get: function get() {
    return _voiceSearchHelper.default;
  }
});

var _reactInstantsearchCore = require("react-instantsearch-core");

var _InstantSearch = _interopRequireDefault(require("./widgets/InstantSearch"));

var _Index = _interopRequireDefault(require("./widgets/Index"));

var _Breadcrumb = _interopRequireDefault(require("./widgets/Breadcrumb"));

var _ClearRefinements = _interopRequireDefault(require("./widgets/ClearRefinements"));

var _CurrentRefinements = _interopRequireDefault(require("./widgets/CurrentRefinements"));

var _HierarchicalMenu = _interopRequireDefault(require("./widgets/HierarchicalMenu"));

var _Highlight = _interopRequireDefault(require("./widgets/Highlight"));

var _Hits = _interopRequireDefault(require("./widgets/Hits"));

var _HitsPerPage = _interopRequireDefault(require("./widgets/HitsPerPage"));

var _InfiniteHits = _interopRequireDefault(require("./widgets/InfiniteHits"));

var _Menu = _interopRequireDefault(require("./widgets/Menu"));

var _MenuSelect = _interopRequireDefault(require("./widgets/MenuSelect"));

var _NumericMenu = _interopRequireDefault(require("./widgets/NumericMenu"));

var _Pagination = _interopRequireDefault(require("./widgets/Pagination"));

var _Panel = _interopRequireDefault(require("./widgets/Panel"));

var _PoweredBy = _interopRequireDefault(require("./widgets/PoweredBy"));

var _RangeInput = _interopRequireDefault(require("./widgets/RangeInput"));

var _RangeSlider = _interopRequireDefault(require("./widgets/RangeSlider"));

var _RatingMenu = _interopRequireDefault(require("./widgets/RatingMenu"));

var _RefinementList = _interopRequireDefault(require("./widgets/RefinementList"));

var _ScrollTo = _interopRequireDefault(require("./widgets/ScrollTo"));

var _SearchBox = _interopRequireDefault(require("./widgets/SearchBox"));

var _Snippet = _interopRequireDefault(require("./widgets/Snippet"));

var _SortBy = _interopRequireDefault(require("./widgets/SortBy"));

var _Stats = _interopRequireDefault(require("./widgets/Stats"));

var _ToggleRefinement = _interopRequireDefault(require("./widgets/ToggleRefinement"));

var _VoiceSearch = _interopRequireDefault(require("./widgets/VoiceSearch"));

var _QueryRuleCustomData = _interopRequireDefault(require("./widgets/QueryRuleCustomData"));

var _utils = require("./core/utils");

var _voiceSearchHelper = _interopRequireDefault(require("./lib/voiceSearchHelper"));


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-dom/dist/cjs/index.js
// module id = 2117
// module chunks = 142807904292071